var render = function render(){
  var _vm$data;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "w-100"
  }, [_c('table', {
    staticClass: "w-100"
  }, [_vm._m(0), _c('tbody', _vm._l(_vm.data, function (item, index) {
    var _item$activity$name, _item$notes;
    return _c('tr', {
      key: index,
      staticClass: "bg-white"
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _c('td', [_vm._v(_vm._s(_vm.formatDate(item === null || item === void 0 ? void 0 : item.date_of_activity)) + " - " + _vm._s(_vm.formatDate(item === null || item === void 0 ? void 0 : item.end_of_activity)))]), _c('td', [_vm._v(_vm._s((_item$activity$name = item.activity.name) !== null && _item$activity$name !== void 0 ? _item$activity$name : '-'))]), _c('td', [_vm._v(_vm._s((_item$notes = item.notes) !== null && _item$notes !== void 0 ? _item$notes : '-'))]), _c('td', _vm._l(_vm.toJosnParse(item.file), function (url, idx) {
      return _c('div', {
        key: idx,
        staticClass: "mb-1",
        staticStyle: {
          "width": "120px"
        }
      }, [_c('b-badge', {
        staticClass: "d-flex align-items-center justify-content-between",
        on: {
          "click": function click($event) {
            return _vm.handleDownloadFile(url);
          }
        }
      }, [_c('div', {
        staticClass: "text-white cursor-pointer"
      }, [_c('div', {
        staticClass: "d-flex align-items-center"
      }, [_c('i', {
        staticClass: "fa fa-download cursor-pointer"
      }), _c('p', {
        staticClass: "ml-2 mb-0"
      }, [_vm._v("Attachment")])])])])], 1);
    }), 0)]);
  }), 0)]), !((_vm$data = _vm.data) !== null && _vm$data !== void 0 && _vm$data.length) ? _c('div', {
    staticClass: "p-3 d-flex justify-content-center"
  }, [_c('img', {
    attrs: {
      "src": require('@/public/img/not-found-image.png'),
      "alt": "not-found-image",
      "width": "160",
      "height": "140"
    }
  })]) : _vm._e()]);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('thead', [_c('th', {
    staticClass: "text-nowrap",
    staticStyle: {
      "width": "40px"
    }
  }, [_vm._v("No")]), _c('th', {
    staticClass: "text-nowrap"
  }, [_vm._v("Date Activity")]), _c('th', {
    staticClass: "text-nowrap"
  }, [_vm._v("Activity Name")]), _c('th', {
    staticClass: "text-nowrap"
  }, [_vm._v("Remarks")]), _c('th', {
    staticClass: "text-nowrap"
  }, [_vm._v("Attachment Activity")])]);

}]

export { render, staticRenderFns }